import React, { useContext } from 'react'
import { navigate } from 'gatsby'
import StoreContext from '~/context/StoreContext'
import LineItem from './LineItem'
import styled from '@emotion/styled'
import { breakpoints } from '~/utils/styles'
import Button from '~/components/Button'
import Heading from '~/components/Heading'
import { Loader } from '~/utils/styles'

const Cart = () => {
  const {
    store: { checkout },
  } = useContext(StoreContext)

  const handleCheckout = () => {
    const url = checkout.webUrl.replace(
      'eatnooro.myshopify.com',
      'shop.getnooro.com'
    )
    navigate(url)
  }

  const lineItems = checkout.lineItems.map(item => (
    <LineItem key={item.id.toString()} item={item} />
  ))

  const isEmpty = checkout.lineItems.length === 0

  return (
    <Padding>
      <Drawer>
        {!checkout.id ? (
          <Empty>
            <Loader backgroundColor="#ffffff" />
          </Empty>
        ) : isEmpty ? (
          <Empty>
            <div style={{ width: '100%' }}>
              <Heading fontSize="28px">Your cart is empty</Heading>
              <a
                href="/"
                style={{
                  maxWidth: 340,
                  display: 'block',
                  margin: '30px auto 0',
                }}
              >
                <Button>Fuel your flow state &rarr;</Button>
              </a>
            </div>
          </Empty>
        ) : (
          <div>{lineItems}</div>
        )}
      </Drawer>
      {!isEmpty && (
        <Button
          onClick={handleCheckout}
          disabled={checkout.lineItems.length === 0}
        >
          Checkout
          <span style={{ margin: '0 15px', display: 'inline-blocks' }}>
            &rarr;
          </span>{' '}
          £{checkout.totalPrice.replace('.00', '')}
        </Button>
      )}
    </Padding>
  )
}

export default Cart

const Drawer = styled.div`
  width: 100%;
  margin: 30px auto 0;
  padding: 30px;
  box-sizing: border-box;
  background: white;
  margin-bottom: 20px;

  @media (max-width: ${breakpoints.s}px) {
    padding: 20px;
  }
`

const Empty = styled.div`
  text-align: center;
  padding: 50px 0;
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
`

const Padding = styled.div`
  padding-top: 130px;
  width: 100%;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  box-sizing: border-box;

  @media (max-width: ${breakpoints.s}px) {
    padding-top: 98px !important;
    padding-left: 20px;
    padding-right: 20px;
  }
`
